import { render, staticRenderFns } from "./InsureResult.vue?vue&type=template&id=5241c8c3&scoped=true&"
import script from "./InsureResult.vue?vue&type=script&lang=js&"
export * from "./InsureResult.vue?vue&type=script&lang=js&"
import style0 from "./InsureResult.vue?vue&type=style&index=0&id=5241c8c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241c8c3",
  null
  
)

export default component.exports